import React from 'react';
import { useListLiveProjectsQuery } from '../../../../generated/core-api/graphql-react-query';
import useProjectIdContext from '../ProjectIdContext/useProjectIdContext';
import { ProjectInfoContext } from './useProjectInfoContext';

export default function ProjectInfoContextProvider({ children }: { children: React.ReactNode }) {
  const projects = useListLiveProjectsQuery({});
  const { projectId, setProjectId } = useProjectIdContext();

  const value = React.useMemo(() => ({
    project: projects.data?.listProjects.find((p) => p.id === projectId) ?? null,
    projects: projects.data?.listProjects ?? [],
  }), [projectId, projects.data]);

  React.useEffect(() => {
    if (projects.data) {
      if (projects.data.listProjects.length === 0) {
        setProjectId(null);
      } else if (!projectId || !projects.data.listProjects.map((p) => p.id).includes(projectId)) {
        setProjectId(projects.data.listProjects[0].id);
      }
    }
  }, [projects.data, projectId]);

  return (
    <ProjectInfoContext.Provider value={value}>
      {children}
    </ProjectInfoContext.Provider>
  );
}
